"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiHandler = _interopRequireDefault(require("./ApiHandler"));
var _constants = _interopRequireDefault(require("./constants"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let {
  URLs,
  INDEXED_KEYS
} = _constants.default;
class TransactionHandler extends _ApiHandler.default {
  constructor() {
    super(...arguments);
    _defineProperty(this, "baseUrl", URLs.TRANS);
    _defineProperty(this, "getFirstTransactionDate", async _id => {
      let url = "".concat(this.baseUrl, "/firsttrandate/").concat(_id);
      let response = await this.standardGetOperation(url);
      if (response.data && response.data.date) {
        return Promise.resolve((0, _moment.default)(response.data.date, "YYYYMMDD", true).format("YYYY-MM-DD"));
      } else {
        return Promise.reject("No date found.");
      }
    });
    _defineProperty(this, "updateChitStatus", async payload => {
      let url = "".concat(this.baseUrl, "/chit-tran-status/trans");
      return this.standardPatchOperation(url, payload);
      // //this.nav.showOverlay();
      // this.getInstance().patch(url, payload).then(async (response) => {
      //         if (response.status === 400) {
      //             console.log(response)
      //             //this.showError('Error: An internal error occured while saving statuses.');
      //             // reject('internal_error');
      //         }
      //         else {
      //             if (response.data.message) {
      //                 //this.showSuccess(response.data.message);
      //             } else {
      //                 //this.showSuccess('Transaction statuses updated successfully');
      //             }
      //             // resolve('success');
      //         }
      //     })
      //     .catch((error) => {
      //         console.log(error);
      //         let msg = 'An error occurred from the server';
      //         try {
      //             if (error.response.data.message) msg = error.response.data.message
      //         } catch (error) {}
      //         //this.showError(msg);
      //         // reject(msg);
      //     })
      //     .finally(()=>{
      //         //this.nav.hideOverlay();
      //         //this.nav.reload();
      //     })
    });
    _defineProperty(this, "getPaymentDashboardData", async acId => {
      let url = "".concat(this.baseUrl, "/chit-tran-status/account/").concat(acId);
      if (this.store.Session.get(acId + '_req_ts')) {
        url += '?request=' + this.store.Session.get(acId + '_req_ts');
        this.store.Session.unset(acId + '_req_ts');
      }
      try {
        let resp = await this.standardGetOperation(url);
        return Promise.resolve(resp.data.statusTable);
      } catch (error) {
        return Promise.reject('Unable to fetch payment grid at this time. Please try again later.');
      }
      // let resp = await this.standardGetOperation(url)
      // return resp.data.statusTable;
      // return new Promise((resolve, reject)=>{
      //     if (!ac) {
      //         //this.showWarn('Please select an account to recalculate.');
      //         reject('account_not_selected');
      //     } else {
      //         this.getInstance().get(url).then((resp)=>{
      //             resolve(resp.data.statusTable)
      //         }).catch((err)=>{
      //             console.error(err);
      //             //this.showError('An internal error occured while fetching the dashboard')
      //             reject('error')
      //         }).finally(()=>{
      //             //this.nav.hideOverlay();
      //         })
      //     }
      // });
    });
  }
  recalculateAccount() {
    let ac = this.getActiveAccount();
    if (!ac) {
      //this.showWarn('Please select an account to recalculate.');
      return;
    }
    let url = "".concat(this.baseUrl, "/recalculate/").concat(ac);
    return new Promise((resolve, reject) => {
      this.getInstance().post(url).then(response => {
        //this.showSuccess(response.data.message);
        if (response.data.doRefresh) this.comp.handleRefreshRequest();
        resolve(true);
      }).catch(err => this.handleError(err, "Error while recalculating account. Try again."));
    });
  }
  reorderAccount() {
    let by = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'date';
    let ac = this.getActiveAccount();
    if (!ac) {
      //this.showWarn('Please select an account to reorder.');
      return;
    }
    let url = "".concat(this.baseUrl, "/reorder/").concat(ac, "/").concat(by);
    return new Promise((resolve, reject) => {
      this.getInstance().post(url).then(response => {
        //this.showSuccess(response.data.message);
        resolve(true);
      }).catch(err => this.handleError(err, "Error while reordering account. Try again."));
    });
  }
  refreshBeneficiaries() {
    let ac = this.getActiveAccount();
    if (!ac) {
      //this.showWarn('Please select an account to recalculate.');
      return;
    }
    let url = "".concat(this.baseUrl, "/batch/synclinkac");
    let payload = {
      account: ac
    };
    return new Promise((resolve, reject) => {
      this.getInstance().post(url, payload).then(response => {
        //this.showSuccess(`Beneficiaries synced successfully [${response.data.message}]`);
        if (response.data.counts.updates > 0 && this.comp.props.onRefreshTranGrid) {
          this.comp.props.onRefreshTranGrid(true);
        }
        resolve(true);
      }).catch(err => this.handleError(err, "Error while syncing beneficiaries. Try again."));
    });
  }
  unLinkTransactions() {
    let ids = this.comp.props.rowsToUnlink.reduce((arr, tran) => {
      arr.push(tran._id);
      return arr;
    }, []);
    if (ids.length === 0) {
      //this.showWarn('No transactions selected to unlink.');
      return;
    }
    let url = "".concat(this.baseUrl, "/bulkunlink");
    let payload = {
      ids
    };
    return new Promise((resolve, reject) => {
      this.getInstance().post(url, payload).then(response => {
        //this.showSuccess(response.data.message);
        // if(response.data.doRefresh) 
        this.comp.handleRefreshRequest();
        resolve(true);
      }).catch(err => this.handleError(err, "Error while unlinking selected transactions. Try again."));
    });
  }
  cloneTransaction() {
    let {
      _id
    } = this.comp.props.rowsSelected[0];
    if (!_id) {
      //this.showWarn('No transactions selected to unlink.');
      return;
    }
    let url = "".concat(this.baseUrl, "/clone/").concat(_id);
    return new Promise((resolve, reject) => {
      this.getInstance().post(url).then(response => {
        // let updatedTransaction = response.data;
        //this.showSuccess('Transaction cloned successfully');
        this.recalculateAccount();
        // if(response.data.doRefresh) 
        // this.comp.handleRefreshRequest();
        resolve(true);
      }).catch(err => this.handleError(err, "Error while cloning selected transaction. Try again."));
    });
  }
  getPaymentDashboardDataCached(acId) {
    let unset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return this.cachedResponse(unset, INDEXED_KEYS.TRAN_DASHBOARD + "_" + acId, this.getPaymentDashboardData, [acId]);
  }
  /*
  
  	updateAccount = async () => {
  		// this.props.enqueueSnackbar('This action is not ready yet', {
  		// 	variant : 'warning'
  		// });
  		// return;
  		// let _account = this.state.account;
  		// TODO: make this error disable the submit button in 'FieldsErrorFree' logic similar to new list item. 
  		if (this.props.account.code === 'unknown') {
  			this.props.enqueueSnackbar('Selected Account is invalid. Transaction cannot be added.', {
  				variant : 'error'
  			});
  			return;
  		}
  		let _schedule = this.state.schedule;
  		let _actionInProgress = this.state.actionInProgress;
  		// _actionInProgress.disableActionButton = true;
  		// _actionInProgress.openLinearLoading = true;
  		// this.setState({
  		// 	actionInProgress : _actionInProgress
  		// });
  		
  		let preparedPayload = this.preparePayload(_schedule);
  		// console.log('preparedPayload', preparedPayload);
  		// return;	
  		//inject chit_info
  		// preparedPayload.chit_info = this.state.tranChitInfo;
  		// console.log('preparedReleaseObject', preparedReleaseObject)
  		let responseErr = '';
  		await getInstance()
  			.post(`${Constants.URLs.ACCOUNT_SCHEDULE}/ac/${this.state.selectedAccount._id}`, preparedPayload)
  			.then(async (response) => {
  				if (response.status === 400) {
  					console.log(response)
  					this.props.enqueueSnackbar('Error: An internal error occured while saving account schedule.', {
  						variant : 'error'
  					});
  					responseErr = response.data.message
  				}
  				else {
  					this.props.enqueueSnackbar('Account schedule updated successfully', {
  						variant : 'success'
  					});
  					// _transaction = _cloneDeep(tranObject)
  					// _schedule = _cloneDeep(accountCCStmtScheduleObj)
  				}
  			})
  			.catch((error) => {
  				console.log(error);
                  let msg = 'An error occurred from the server';
                  try {
                      if (error.response.data.message) msg = error.response.data.message
                  } catch (error) {}
                  responseErr = msg;
  				this.props.enqueueSnackbar(msg, {
  					variant : 'error'
  				});
  			})
  			.finally(()=>{
  				_actionInProgress.disableActionButton = false;
  				_actionInProgress.openLinearLoading = false;
  				this.setState({
  					sqlErrorMessage  : responseErr,
  					// transaction: _transaction,
  					// schedule: _schedule,
  					actionInProgress : _actionInProgress
  				});
  				if (responseErr === '') {
  					this.props.onSubmit();
  				}
  			})
  	}
  */
}
exports.default = TransactionHandler;